module.exports = __webpack_public_path__ + "img/header_landing.3cc5be83.png";